import React from 'react';

import { PublicPage } from 'api/website';
import Box from 'components/Box';
import Icon from 'components/Icon';
import { SocialButton } from 'components/SocialButton';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export default ({
  content,
  message,
  title,
  subsite,
}: {
  content: PublicPage;
  message: string | null | undefined;
  title: string;
  subsite: string;
}) => (
  <>
    <SocialButton
      object={content}
      objectType="CMS_PAGE"
      socialType="facebook"
      utmParams={{}}
      message={message}
      eventName="Share post"
      eventProperties={{
        title,
        subsite,
      }}
    >
      <Box
        width={32}
        height={32}
        classes={['flex', 'justify-center', 'align-center']}
      >
        <Icon name="facebook" width={14} height={14} fill="currentColor" />
      </Box>
    </SocialButton>

    <SocialButton
      object={content}
      objectType="CMS_PAGE"
      socialType="twitter"
      utmParams={{}}
      message={message}
      eventName="Share post"
      eventProperties={{
        title,
        subsite,
      }}
    >
      <Box
        width={32}
        height={32}
        classes={['flex', 'justify-center', 'align-center']}
      >
        <Icon name="twitter" width={14} height={14} fill="currentColor" />
      </Box>
    </SocialButton>

    <SocialButton
      object={content}
      objectType="CMS_PAGE"
      socialType="linkedin"
      utmParams={{}}
      message={message}
      eventName="Share post"
      eventProperties={{
        title,
        subsite,
      }}
    >
      <Box
        width={32}
        height={32}
        classes={['flex', 'justify-center', 'align-center']}
      >
        <Icon name="linkedin" width={14} height={14} fill="currentColor" />
      </Box>
    </SocialButton>
  </>
);
